module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-008"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("IMPENDING JUDGMENT ON ISRAEL AND JUDAH"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+5%3A1-15&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 5:1-15")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The shepherds by right living provide the flock with pure waters of truth. However, when they pollute the water by evil living, they jeopardize the lives of their flock (G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v("). Christ is our educator who leads us to eternal life and imparts the necessary truth to save us (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). That God knows Ephraim means that God loves Ephraim, and God will correct Ephraim in love rather than anger (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v("). The spirit of whoredom blocks Israel’s knowledge of God (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Baptism regenerates believers and leads them away from their fallen nature (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODOTUS")]), _vm._v("). God becomes like a moth, or rot, by allowing a long time for penitence. Human terms of place do not completely fit when discussing God’s place (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). To seek God’s face is to seek Christ. Those who come to their senses will stop worshiping idols and turn to seek God (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(").")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-055"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("5:1 "), _c('i', [_vm._v("Israel’s Judgment")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OW")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUL THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCK’S")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATER.")])]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGORY THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(": For indeed the shepherds drink most pure water, when with a right understanding they imbibe the streams of truth. But to foul the same water with their feet is to corrupt the studies of holy meditation by evil living. And truly the sheep drink the water fouled by their feet, when any of those subject to them follow not the words that they hear but only imitate the bad examples that they see. Thirsting for things said but perverted by the works observed, they take in mud with their draughts, as from polluted fountains. Hence also it is written through the prophet, “A snare for the downfall of my people are evil spirits.” P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTORAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARE 1.2.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN133",
      "id": "ap_NFIN133-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-056"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:2"), _c('i', [_vm._v(" Chastising All")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DUCATES THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AITHFUL.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": Therefore the Word who leads us his children to salvation is unquestionably an educator of little ones. In fact, through Hosea, the Word says plainly of himself, “I am your educator.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN134",
      "id": "ap_NFIN134-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The matter he educates us in is fear of God, for this fear instructs us in the service of God, educates to the knowledge of truth, and guides by a path leading straight up to heaven. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DUCATOR 1.7.53.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN135",
      "id": "ap_NFIN135-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-057"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:3"), _c('i', [_vm._v(" I Know Ephraim")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOW")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S TO")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v(": That “I know” means “I loved” is seen from God’s words: “I instruct them because I loved Ephraim, and I did not remove Israel from me. For though she plays the whore in idolatry, nevertheless I would not reject her, but I will be with her.” This is in harmony with what the prophet was told in the beginning, when he was ordered to marry a whore. Who would not love an instructor who corrects with love rather than with anger? This is also the instruction pertaining to every leader: to chastise not for anger but for education and assistance. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN136",
      "id": "ap_NFIN136-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-058"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:4"), _c('i', [_vm._v(" They Do Not Know the Lord")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOREDOM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOCKS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NOWLEDGE.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": First the king [Jeroboam I] chose to play the whore away from the worship of God, wishing to adore golden calves. And the people followed him willingly—with equal zeal they accomplished equal ungodliness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN137",
      "id": "ap_NFIN137-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" They do not return to the Lord, for they found what they were looking for, and the spirit of whoredom—which according to the apostle “works in the sons of distrust”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN138",
      "id": "ap_NFIN138-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v("—holds their hearts captive. As long as it governs, they will not know the Lord. In fact, they forgot their Creator. . . . They—whoever advances in ruin—do not have thoughts of penitence. For the spirit of whoredom, by which they played the whore in the church and by which they went away from the true marriage, dwells in "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("their midst. That is why they did not know the Lord. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 1.5.")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN139",
      "id": "ap_NFIN139-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-059"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:8 "), _c('i', [_vm._v("Sound a Warning")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EACHER.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODOTUS THE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALENTINIAN")]), _vm._v(" : The Spirit through Hosea says, “I will correct you.” “Blow the trumpet upon the hills of the Lord; let it sound upon the high places.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN140",
      "id": "ap_NFIN140-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" And is not baptism itself, which is the sign of regeneration, a transcending of the flesh, which is a great impetuous stream, ever rushing on and bearing us along? The teaching of the Lord accordingly leads us out of disorder, illumines us by bringing us into light, beyond the shadows of unilluminated matter. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCERPTS OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODOTUS 5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN141",
      "id": "ap_NFIN141-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-060"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:12"), _c('i', [_vm._v(" Like a Moth, Like Dry-Rot")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URPRISING")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETAPHOR.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": Just as the moth consumes clothing and decay or dry-rot consumes wooden things (which both occur over a long time), in the same manner God, giving a place of penitence over a long time to the ten tribes and then afterward to the two tribes—summoning to salvation those who treasure for themselves wrath for the day of wrath—becomes like a moth or rot. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 2.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN142",
      "id": "ap_NFIN142-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-061"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5:15 "), _c('i', [_vm._v("I Will Go Back to My Place")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LACE.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": By “my place” we have to understand God’s place, his splendor and majesty, so that by no means according to the dispensation does he descend to men, become angry, merciful, forgetful, become as a panther, turn into a lion, change into beasts. On the contrary, he disdains human things and allows those whom he once protected to be cast to enemies so that they may languish, disappear and be destroyed, and seek eventually the face of the Lord. . . . Others consider God’s place the heaven where God returns after being offended by the inhabitants of the earth, and he allows to go to ruin those who, due to the multitude of their sins, turned the mercy of the Lord into the rage of beasts toward them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 2.5.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN143",
      "id": "ap_NFIN143-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD’S")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": It seems that the saying refers very suitably to the mystery of Christ and the redemption through him, pointing to the conversion to God. For the face of God we seek signifies most certainly the Son himself, “who is the image, and the radiance, and the very seal of the Father’s nature.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN144",
      "id": "ap_NFIN144-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Thus the true face of God and Father is the Son, inasmuch as he is recognized in him: “And who saw him, saw the Father.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN145",
      "id": "ap_NFIN145-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The psalmist thus calls him when he cries out to God of all, saying: “Cause your face to shine upon your servant.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN146",
      "id": "ap_NFIN146-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Indeed, just as from the person of those who were already transformed according to the Son through the Spirit: “The light of your face, O Lord, has been marked upon us.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN147",
      "id": "ap_NFIN147-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Or as the prophet says: “The light of our face, the anointed Lord.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN148",
      "id": "ap_NFIN148-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.61.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN149",
      "id": "ap_NFIN149-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVINE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HASTISEMENT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAKENS THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE TO")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPENTANCE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": “They seek early” seems to indicate here that they, as if awakened from the sleep of thoughtlessness which was in them, and further as if brought from night and darkness to light and day, will call out to one another that it is fitting to return to the Lord. This is a return to the senses of those fallen into deception and those taken up by the worship of idols. For the fruit of vigilance is at present seeking to get out of the gloom which is demonic. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.62.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN150",
      "id": "ap_NFIN150-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e4d57c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap9.vue
// module id = 105
// module chunks = 0